<template>
    <transition name="fade" v-if="isVisiable">
        <div class="location-by-ip" :style="{...locateContent.style,backgroundImage:`url(${locateContent.imageUrl})`}">
            <div class="action-box">
                <img @click="changeFn()" :src="locateContent.changeBtn.imageUrl" :style="locateContent.changeBtn.style" />
                <img @click="helpFn()" :src="locateContent.helpBtn.imageUrl" :style="locateContent.helpBtn.style" />
                <img @click="closeFn()" :src="locateContent.closeBtn.imageUrl" :style="locateContent.closeBtn.style" />
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    data() {
        return {
            isVisiable: true,
            appCacheType: '',
            locateStyle: 1,
            interval: null,
            styleConfig: {
                showTime: '',
                position: 'top',
                bgImg: '',
                changeImg: '',
                helpImg: '',
                closeImg: '',
            },
        }
    },
    computed: {
        locateContent() {
            let style =
                this.locateStyle === 1
                    ? {
                          imageUrl:
                              this.styleConfig.bgImg ||
                              'https://file.40017.cn/img140017cnproduct/cn/c/all/ui/locate_bg1.png',
                          style: {
                              width: '21.875rem',
                              height: '1.78125rem',
                              left: '0.78125rem',
                              padding: '0.28125rem 0.5rem',
                              backgroundSize: '100% 100%',
                          },
                          changeBtn: {
                              imageUrl:
                                  this.styleConfig.changeImg ||
                                  'https://file.40017.cn/img140017cnproduct/cn/c/all/ui/btn_change1.png',
                              style: {
                                  width: '3.1875rem',
                                  height: '1.25rem',
                                  marginRight: '0.5rem',
                                  verticalAlign: 'middle',
                              },
                          },
                          helpBtn: {
                              imageUrl:
                                  this.styleConfig.helpImg ||
                                  'https://file.40017.cn/img140017cnproduct/cn/c/all/ui/btn_help1.png',
                              style: {
                                  width: '3.1875rem',
                                  height: '1.25rem',
                                  marginRight: '0.5rem',
                                  verticalAlign: 'middle',
                              },
                          },
                          closeBtn: {
                              imageUrl:
                                  this.styleConfig.closeImg ||
                                  'https://file.40017.cn/img140017cnproduct/cn/c/all/ui/close.png',
                              style: {
                                  width: '0.625rem',
                                  height: '0.7185rem',
                                  verticalAlign: 'middle',
                              },
                          },
                      }
                    : {
                          imageUrl:
                              this.styleConfig.bgImg ||
                              `https://file.40017.cn/img140017cnproduct/cn/c/all/ui/locate_bg2.png`,
                          style: {
                              width: '22.4375rem',
                              height: '1.90625rem',
                              left: '0.5rem',
                              padding: '0.28125rem 0.75rem',
                              backgroundSize: '100% 100%',
                          },
                          changeBtn: {
                              imageUrl:
                                  this.styleConfig.changeImg ||
                                  'https://file.40017.cn/img140017cnproduct/cn/c/all/ui/btn_change.png',
                              style: {
                                  width: '3.5rem',
                                  height: '1.25rem',
                                  marginRight: '0.5rem',
                                  verticalAlign: 'middle',
                              },
                          },
                          helpBtn: {
                              imageUrl:
                                  this.styleConfig.helpImg ||
                                  'https://file.40017.cn/img140017cnproduct/cn/c/all/ui/btn_help.png',
                              style: {
                                  width: '3.625rem',
                                  height: '1.375rem',
                                  marginRight: '0.5rem',
                                  verticalAlign: 'middle',
                              },
                          },
                          closeBtn: {
                              imageUrl:
                                  this.styleConfig.closeImg ||
                                  'https://file.40017.cn/img140017cnproduct/cn/c/all/ui/close_black.png',
                              style: {
                                  width: '0.625rem',
                                  height: '0.7185rem',
                                  verticalAlign: 'middle',
                              },
                          },
                      }
            if (
                this.styleConfig.position === 'top' ||
                this.styleConfig.position === 'bottom'
            ) {
                style.style.position = 'fixed'
                style.style[this.styleConfig.position] = '0.25rem'
                style.style.zIndex = 800
            } else {
                style.style.float = 'right'
                style.style.padding = '0 0.5rem'
                style.style.marginRight = '1rem'
                style.style.width = '16.4rem'
                style.style.height = '1.375rem'
                style.changeBtn.style.width = '2.5rem'
                style.changeBtn.style.height = '1rem'
                style.helpBtn.style.width = '2.5rem'
                style.helpBtn.style.height = '1rem'
                style.closeBtn.style.width = '0.4375rem'
                style.closeBtn.style.height = '0.5625rem'
            }
            return style
        },
    },
    beforeDestroy() {
        clearTimeout(this.interval)
    },
    mounted() {
        this.interval = setTimeout(() => {
            this.isVisiable = false
        }, this.styleConfig.showTime || 3000)
        window.AllBridge.allEventTrack({
            category: 'alle_page',
            action: `all_Location_pop_open`,
        })
    },
}
</script>
<style scoped lang="less">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.location-by-ip {
    .action-box {
        float: right;
    }
}
</style>
